// Texto en mono que se copia con un clic; confirma con «copiado ✓» un momento.
import { useEffect, useState } from 'react';
import { cn } from '@/lib/cn';

export function CopyText({ value, label }: { value: string; label: string }) {
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (!copied) return;
        const timer = setTimeout(() => {
            setCopied(false);
        }, 1200);
        return () => {
            clearTimeout(timer);
        };
    }, [copied]);
    return (
        <button
            type="button"
            title={`Copiar ${label}`}
            aria-label={`Copiar ${label} ${value}`}
            onClick={() => {
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- falta en contextos no seguros
                if (!navigator.clipboard) return;
                void navigator.clipboard.writeText(value).then(() => {
                    setCopied(true);
                });
            }}
            className={cn(
                'max-w-full truncate rounded-[3px] px-1.5 py-px font-mono text-[10.5px]',
                copied
                    ? 'bg-success-soft text-success'
                    : 'bg-muted text-foreground hover:bg-accent',
            )}
        >
            {copied ? 'copiado ✓' : value}
        </button>
    );
}
